import React from 'react';
import PropTypes from 'prop-types';

const SimpleHeaderCell = ({ header }) => (
  <span>
    {header}
  </span>
);

SimpleHeaderCell.propTypes = {
  header: PropTypes.string
};

SimpleHeaderCell.defaultProps = {
  header: ''
};

export default SimpleHeaderCell;
